import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import WebInstall from '../../integrate/_snippets/install-web.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Important:`}</strong>{` When installing PostHog via a package manager, surveys require `}<inlineCode parentName="p">{`posthog-js v1.81.1+`}</inlineCode>{`. It's recommended to install the latest version.`}</p>
    </blockquote>
    <p>{`To get started with surveys, add PostHog to your web app by installing our `}<a parentName="p" {...{
        "href": "/docs/libraries/js"
      }}>{`Javascript web SDK`}</a>{` (if you haven't already). There are two methods to do so:`}</p>

    <WebInstall mdxType="WebInstall" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      